import { usePlangroups, useSelectedPlangroups } from '../dayplanning.hooks';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/Badge/badge';
import { Filter } from 'lucide-react';

/**
 * Dropdown filter for selecting plangroups (teams) to filter technicians
 * Selections are persisted in localStorage
 */
export function PlangroupFilter() {
  const { data: plangroups = [] } = usePlangroups();
  const [selectedIds, setSelectedIds] = useSelectedPlangroups();

  const togglePlangroup = (id: number) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const clearAll = () => setSelectedIds([]);
  const selectAll = () => setSelectedIds(plangroups.map((pg) => pg.id));

  const selectedCount = selectedIds.length;
  const allSelected =
    selectedCount === plangroups.length && plangroups.length > 0;
  const noneSelected = selectedCount === 0;

  // Don't render if no plangroups available
  if (plangroups.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Filter className="h-4 w-4" />
          <span className="hidden md:block">Teams</span>
          {selectedCount > 0 && !allSelected && (
            <Badge variant="secondary" className="ml-1">
              {selectedCount}
            </Badge>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuCheckboxItem
          checked={noneSelected || allSelected}
          onCheckedChange={() => (noneSelected ? selectAll() : clearAll())}
        >
          {noneSelected ? 'All Teams' : 'Clear Selection'}
        </DropdownMenuCheckboxItem>
        <DropdownMenuSeparator />
        {plangroups.map((pg) => (
          <DropdownMenuCheckboxItem
            key={pg.id}
            checked={selectedIds.includes(pg.id)}
            onCheckedChange={() => togglePlangroup(pg.id)}
          >
            {pg.name}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
